export enum TimeGranularity {
  day = 'day',
  week = 'week',
  month = 'month',
}

export const timeGranularityOptions = ['month', 'week', 'day'] as const
